import { defineStore } from "pinia";
import { ref, reactive } from "vue";
import svc from "@/services/super-purchase.service";
import * as Toast from "@/utils/toast";

const notifyError = (msg) => {
  if (Toast?.toast?.error) return Toast.toast.error(msg);
  if (typeof Toast?.toast === "function") return Toast.toast(msg, "error");
  if (Toast?.error) return Toast.error(msg);
  if (typeof Toast === "function") return Toast(msg, "error");
  console.error(msg);
};

const notifySuccess = (msg) => {
  if (Toast?.toast?.success) return Toast.toast.success(msg);
  if (typeof Toast?.toast === "function") return Toast.toast(msg, "success");
  if (Toast?.success) return Toast.success(msg);
  if (typeof Toast === "function") return Toast(msg, "success");
  console.log(msg);
};

export const usePurchaseTransactionStore = defineStore(
  "purchaseTransactions",
  () => {
    const items = ref([]);
    const meta = ref({ total: 0, per_page: 25, current_page: 1 });
    const summary = ref({
      gross_billed: 0,
      paid_total: 0,
      pending_total: 0,
      refunded_total: 0,
      failed_total: 0,
    });
    const loading = ref(false);

    const filters = reactive({
      payment_method: "",
      payment_status: "",
      from: "",
      to: "",
      q: "",
    });

    async function fetchTransactions(extra = {}) {
      loading.value = true;
      try {
        const params = {
          per_page: 1000,
          page: meta.value.current_page,
          ...filters,
          ...extra,
        };

        const res = await svc.fetch(params);
        const list = Array.isArray(res.data)
          ? res.data
          : res.data?.data || res.data || [];

        items.value = list;
        if (res.meta || res.data?.meta) {
          meta.value = res.meta || res.data.meta;
          summary.value = (res.meta || res.data.meta)?.summary || summary.value;
        }
      } catch (e) {
        console.error(e);
        notifyError("Failed to load transactions.");
      } finally {
        loading.value = false;
      }
    }

    async function removeTransaction(id) {
      loading.value = true;
      try {
        await svc.remove(id);
        notifySuccess("Transaction deleted.");
        await fetchTransactions();
      } catch (e) {
        console.error(e);
        notifyError("Failed to delete transaction.");
        throw e;
      } finally {
        loading.value = false;
      }
    }

    return {
      items,
      meta,
      summary,
      loading,
      filters,
      fetchTransactions,
      removeTransaction,
    };
  }
);
